import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useState, useEffect, memo } from "react";
// material
import { styled } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  Grid,
  Paper,
  TextField,
  Button,
  MenuItem,
  Stack,
  Chip, Autocomplete,
} from "@material-ui/core";
import { objectID } from "../../../utils/objectID";
import ColorSinglePicker from "../../ColorSinglePicker";
import { Icon } from "@iconify/react";
import useAuth from "../../../hooks/useAuth";
import * as Yup from "yup";
import { Form, FormikProvider, useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack5";
// import AddIcon from "@material-ui/icons/Add";
import apiContact from "../../../api/contact";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SaveIcon from "@mui/icons-material/Save";
import apiUser from "../../../api/user";
import ColorTagMultiPicker from "../../ColorTagMultiPicker";
// ----------------------------------------------------------------------

const RootStyle = styled("div")({
  flexGrow: 1,
  display: "flex",
  overflow: "hidden",
  flexDirection: "column",
});

// ----------------------------------------------------------------------

export default memo(function ListFieldContact({
  initialValues,
  infoContact,
  fieldContact,
  listUser,
  validation,
  loadInfoContact,
}) {
  const [searchParams] = useSearchParams();
  const pageParam = searchParams.get("page");
  const rowsParam = searchParams.get("rows");
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedColorsInfo, setSelectedColorsInfo] = useState([]);
  const [errorAddTag, setErrorAddTag] = useState(false);
  const [messageErrorAddTag, setMessageErrorAddTag] = useState("");
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const NewUserSchema = Yup.object().shape(validation);
  const { user } = useAuth();
  const { t } = useTranslation();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues || {},
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        values.id = objectID(infoContact._id);
        values.uid = infoContact.uid;
        await apiContact.edit(values);
        enqueueSnackbar(t("update_success"), { variant: "success" });
        navigate(`/contact/list?page=${pageParam}&rows=${rowsParam}`);
      } catch (error) {
        enqueueSnackbar(error.response.data.message[0], { variant: "error" });
      }
    },
  });

  const {
    errors,
    values,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik;
  const onChangeAssignedBy = (e) => {
    setFieldValue("assigned_by", e.target.value);
  };

  const [isShowEditTag, setIsShowEditTag] = useState(false);
  const [addTags, setAddTags] = useState(false);
  const [colorOptions, setColorOptions] = useState([]);
  // const COLOR_OPTIONS = [
  //   { color: "#FF4842", tag: "VIP" },
  //   { color: "#3BEF37", tag: "Mới" },
  //   { color: "#1890FF", tag: "Quan Tâm" },
  //   { color: "#FFC107", tag: "Thường" },
  //   { color: "#04297A", tag: "Đã Chốt" },
  // ];
  const COLOR_OPTIONS_MORE = [
    "#00AB55", // theme.palette.primary.main,
    "#1890FF", // theme.palette.info.main,
    "#94D82D", // theme.palette.success.main,
    "#FFC107", // theme.palette.warning.main,
    "#FF4842", // theme.palette.error.main
    "#04297A", // theme.palette.info.darker
    "#7A0C2E", // theme.palette.error.darker
  ];

  const findTags = async () => {
    try {
      const res = await apiUser.find_tags();
      if (res.status === 200) {
        let resDataTags = res?.data?.data;
        if (infoContact?.tags && infoContact?.tags.length > 0) {
          const tagsIdsInfo = infoContact?.tags.map((tag) => tag.id); // Extract IDs from tags1
          const filteredTags = resDataTags.filter(
            (tag) => !tagsIdsInfo.includes(tag.id)
          ); // Exclude matching IDs
          setColorOptions(filteredTags);
        } else {
          setColorOptions(resDataTags);
        }
      } else {
        enqueueSnackbar("Không tìm thấy danh sách nhãn, vui lòng thêm nhãn !", {
          variant: "error",
        });
        setColorOptions([]);
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Không tìm thấy danh sách nhãn, vui lòng thêm nhãn !", {
        variant: "error",
      });
      setColorOptions([]);
    }
    // setColorOptions(res?.data);
  };
  useEffect(() => {
    findTags();
  }, [infoContact]);
  const handleChooseTag = (e) => {
    setSelectedColors(e);
    if (e.length > 0) {
      setFieldValue("tags", JSON.stringify(e));
    }
  };
  const handleAddTags = () => {
    setAddTags(!addTags);
    if (!addTags) {
      setFieldValue("tag", "");
      setFieldValue("color", "");
    } else {
      delete values.tag;
      delete values.color;
    }
  };

  const handleAddTag = async () => {
    if (values.tag === "" || values.color === "") {
      setErrorAddTag(true);
      setMessageErrorAddTag("Bạn chưa chọn màu hoặc nhập tên nhãn !!!");
      return;
    }
    if (values.tag.length > 20) {
      setErrorAddTag(true);
      setMessageErrorAddTag("Tên nhãn không quá 20 ký tự !!!");
      return;
    }
    try {
      const insertTag = await apiUser.insert_tags({
        tag: values.tag,
        color: values.color,
      });
      if (insertTag.status === 200) {
        setAddTags(false);
        findTags();
        enqueueSnackbar("Thêm nhãn thành công !", { variant: "success" });
      } else {
        enqueueSnackbar("Thêm nhãn thất bại, vui lòng thử lại !", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Thêm nhãn thất bại, vui lòng thử lại !", {
        variant: "error",
      });
    }
    setErrorAddTag(false);
    setMessageErrorAddTag("");
  };

  const fetchAndMapTags = async () => {
        if (infoContact?.tags && infoContact?.tags.length > 0) {
          try {
            const res = await apiUser.find_and_map_tags_by_arr_id({
              tags_id: infoContact?.tags,
            });
            if (res.status === 200) {
              setSelectedColorsInfo(res?.data?.data || []);
            } else {
              setSelectedColorsInfo([]);
            }
          } catch (error) {
            console.error("Error fetching tags:", error);
            setSelectedColorsInfo([]);
          }
        }
      };

  useEffect(() => {
    if (infoContact?.tags && infoContact?.tags?.length > 0) {
      fetchAndMapTags();
    }
  }, [infoContact?.tags]);
  const handleDeleteTag = async (param, tag) => {
    try {
      await apiContact.delete_tag({
        id: objectID(param._id),
        tag,
      });
      enqueueSnackbar("Xóa thành công", { variant: "success" });
      setSelectedColorsInfo((pre) =>
        pre.filter((tagItem) => tag.id !== tagItem.id)
      );
      loadInfoContact();
    } catch (error) {
      enqueueSnackbar("Vui lòng kiểm tra lại nhãn", { variant: "error" });
    }
    //   findTags();
  };

  const InfoContactTag = () => {
    if (selectedColorsInfo && selectedColorsInfo.length > 0) {
      const renderTags = selectedColorsInfo.map((item) => {
        return (
          <Chip
            label={item.tag}
            onDelete={() => {
              handleDeleteTag(infoContact, item);
            }}
            sx={{
              color: "white",
              backgroundColor: item.color,
              cursor: "pointer",
              mt: 1,
              mr: 0.5,
            }}
          />
        );
      });
      return (
        <Box
          align="center"
          sx={{
            textOverflow: "ellipsis", // Add ellipsis for long text
          }}
          spacing={2}
        >
          {renderTags}
        </Box>
      );
    } else {
      return null;
    }
  };

  const handleOpenShowEditTag = () => {
    setIsShowEditTag(!isShowEditTag);
  };
  const onHandleChangeOptionContactField = (itemKey, variable) =>{
    setFieldValue(variable, itemKey);
  }
  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Box sx={{ mt: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Paper>
                <TextField
                  fullWidth
                  label="Họ và tên*"
                  {...getFieldProps("name")}
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper>
                <TextField
                  fullWidth
                  label="Địa chỉ Email*"
                  {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper>
                <TextField
                  fullWidth
                  label="Số điện thoại*"
                  {...getFieldProps("phone")}
                  // error={Boolean(touched.phone && errors.phone)}
                  // helperText={touched.phone && errors.phone}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper>
                <TextField
                  fullWidth
                  label="Địa chỉ"
                  {...getFieldProps("address")}
                  error={Boolean(touched.address && errors.address)}
                  helperText={touched.address && errors.address}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper>
                <TextField
                  fullWidth
                  label="Công ty"
                  {...getFieldProps("company")}
                  error={Boolean(touched.company && errors.company)}
                  helperText={touched.company && errors.company}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper>
                <TextField
                  fullWidth
                  label="Ghi chú"
                  multiline
                  {...getFieldProps("notes")}
                  error={Boolean(touched.notes && errors.notes)}
                  helperText={touched.notes && errors.notes}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper>
                <TextField
                  select
                  fullWidth
                  label="Người phụ trách"
                  placeholder={t("assigned_by")}
                  name="assigned_by"
                  {...getFieldProps("assigned_by")}
                  error={Boolean(touched.assigned_by && errors.assigned_by)}
                  helperText={touched.assigned_by && errors.assigned_by}
                  onChange={(e) => onChangeAssignedBy(e)}
                  defaultValue={infoContact.assigned_by}
                >
                  <MenuItem value={user.id}>{"Tôi"}</MenuItem>
                  {listUser &&
                    listUser.map((item, index) => {
                      return (
                        <MenuItem key={index} value={objectID(item._id)}>
                          {t(item.full_name)}
                        </MenuItem>
                      );
                    })}
                </TextField>
              </Paper>
            </Grid>
            {fieldContact &&
              fieldContact.map((item, index) => {
                if (item.field_type === "text") {
                  return (
                    <Grid item xs={12} sm={4}>
                      <Paper>
                        <TextField
                          fullWidth
                          multiline
                          label={item.field_name}
                          {...getFieldProps(item.field_variable)}
                          error={Boolean(
                            touched[item.field_variable] &&
                              errors[item.field_variable]
                          )}
                          helperText={
                            touched[item.field_variable] &&
                            errors[item.field_variable]
                          }
                        />
                      </Paper>
                    </Grid>
                  );
                }
                if (item.field_type === "select") {
                  return (
                    <Grid item xs={12} sm={4}>
                      <Paper>
                        {/*<TextField*/}
                        {/*  select*/}
                        {/*  fullWidth*/}
                        {/*  label={item.field_name}*/}
                        {/*  defaultValue={values[item.field_variable]}*/}
                        {/*  {...getFieldProps(item.field_variable)}*/}
                        {/*  error={Boolean(*/}
                        {/*    touched[item.field_variable] &&*/}
                        {/*      errors[item.field_variable]*/}
                        {/*  )}*/}
                        {/*  helperText={*/}
                        {/*    touched[item.field_variable] &&*/}
                        {/*    errors[item.field_variable]*/}
                        {/*  }*/}
                        {/*>*/}
                        {/*  {item.field_options.map((option) => {*/}
                        {/*    return (*/}
                        {/*      <MenuItem value={option.key}>*/}
                        {/*        {option.label}*/}
                        {/*      </MenuItem>*/}
                        {/*    );*/}
                        {/*  })}*/}
                        {/*</TextField>*/}
                        <Autocomplete
                            key={index}
                            id="checkboxes-tags-demo"
                            options={item.field_options}
                            getOptionLabel={(option) => option.label}  // Show label instead of key
                            isOptionEqualToValue={(option, value) => option.key === value.key} // Fix selection behavior
                            value={item.field_options.find(opt => opt.key === values[item.field_variable]) || null} // Ensure correct selection
                            onChange={(event, newValue) => onHandleChangeOptionContactField(newValue?.key, item.field_variable)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label={item.field_name}
                                    placeholder={item.field_name}
                                    error={Boolean(touched[item.field_variable] && errors[item.field_variable])}
                                    helperText={touched[item.field_variable] && errors[item.field_variable]}
                                />
                            )}
                        />
                      </Paper>
                    </Grid>
                  );
                }
                if (item.field_type === "multiselect") {
                  return (
                    <Grid item xs={12} sm={4}>
                      <Paper>
                        <TextField
                          select
                          fullWidth
                          label={item.field_name}
                          {...getFieldProps(item.field_variable)}
                          // Ensure value is an array, defaulting to an empty array if undefined
                          value={
                            Array.isArray(values[item.field_variable])
                              ? values[item.field_variable]
                              : []
                          }
                          error={Boolean(
                            touched[item.field_variable] &&
                              errors[item.field_variable]
                          )}
                          helperText={
                            touched[item.field_variable] &&
                            errors[item.field_variable]
                          }
                          SelectProps={{
                            multiple: true,
                          }}
                        >
                          {item.field_options.map((option) => (
                            <MenuItem key={option.key} value={option.key}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Paper>
                    </Grid>
                  );
                }
                if (item.field_type === "number") {
                  return (
                    <Grid item xs={12} sm={4}>
                      <Paper>
                        <TextField
                          type="number"
                          inputMode="numberic"
                          fullWidth
                          label={item.field_name}
                          {...getFieldProps(item.field_variable)}
                          error={Boolean(
                            touched[item.field_variable] &&
                              errors[item.field_variable]
                          )}
                          helperText={
                            touched[item.field_variable] &&
                            errors[item.field_variable]
                          }
                        />
                      </Paper>
                    </Grid>
                  );
                }
                if (item.field_type === "email") {
                  return (
                    <Grid item xs={12} sm={4}>
                      <Paper>
                        <TextField
                          type="email"
                          inputMode="email"
                          fullWidth
                          label={item.field_name}
                          {...getFieldProps(item.field_variable)}
                          error={Boolean(
                            touched[item.field_variable] &&
                              errors[item.field_variable]
                          )}
                          helperText={
                            touched[item.field_variable] &&
                            errors[item.field_variable]
                          }
                        />
                      </Paper>
                    </Grid>
                  );
                }
                if (item.field_type === "phone") {
                  return (
                    <Grid item xs={12} sm={4}>
                      <Paper>
                        <TextField
                          type="tel"
                          inputMode="tel"
                          fullWidth
                          label={item.field_name}
                          {...getFieldProps(item.field_variable)}
                          error={Boolean(
                            touched[item.field_variable] &&
                              errors[item.field_variable]
                          )}
                          helperText={
                            touched[item.field_variable] &&
                            errors[item.field_variable]
                          }
                        />
                      </Paper>
                    </Grid>
                  );
                }
                if (item.field_type === "dateTime") {
                  return (
                    <Grid item xs={12} sm={4}>
                      <Paper>
                        <TextField
                          type="datetime-local"
                          inputMode="numeric"
                          fullWidth
                          label={item.field_name}
                          InputLabelProps={{ shrink: true }}
                          value={
                            getFieldProps(item.field_variable).value
                              ? new Date(getFieldProps(item.field_variable).value * 1000)
                                  .toISOString()
                                  .slice(0, 16) // format yyyy-MM-ddTHH:mm
                              : ''
                          }
                          onChange={(e) => {
                            const val = e.target.value;
                            const timestamp = val ? Math.floor(new Date(val).getTime() / 1000) : null;
                            setFieldValue(item.field_variable, timestamp);
                          }}
                          error={Boolean(
                            touched[item.field_variable] &&
                              errors[item.field_variable]
                          )}
                          helperText={
                            touched[item.field_variable] &&
                            errors[item.field_variable]
                          }
                        />
                      </Paper>
                    </Grid>
                  );
                }
              })}
            <Grid item xs={12} sm={12}>
              <Paper>
                <Stack direction="column" spacing={1} sx={{ pl: 1 }}>
                  <Stack direction={"column"} spacing={1}>
                    <Typography variant="body2" sx={{ fontSize: "13px" }}>
                      <strong>Nhãn:</strong>
                    </Typography>
                    <Stack direction="row" spacing={1}>
                      <InfoContactTag />
                      {infoContact?.tags && (
                        <ModeEditIcon
                          onClick={() => handleOpenShowEditTag()}
                          sx={{ cursor: "pointer" }}
                        />
                      )}
                    </Stack>
                  </Stack>
                  {(isShowEditTag ||
                    !infoContact.hasOwnProperty("color_tag")) && (
                    <>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        {!addTags ? (
                          <ColorTagMultiPicker
                            onChange={(e) => handleChooseTag(e)}
                            selectedColors={selectedColors}
                            colors={colorOptions}
                          />
                        ) : null}
                        <Box>
                          <Button
                            onClick={() => handleAddTags()}
                            startIcon={
                              addTags ? (
                                <Icon icon="icon-park-outline:down-two" />
                              ) : (
                                <Icon icon="typcn:plus-outline" />
                              )
                            }
                            variant="outlined"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {addTags ? "Hủy thêm nhãn" : "Thêm Nhãn"}
                          </Button>
                        </Box>
                      </Stack>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        {addTags ? (
                          <>
                            <ColorSinglePicker
                              colors={COLOR_OPTIONS_MORE}
                              {...getFieldProps("color")}
                            />
                            <TextField
                              error={errorAddTag}
                              helperText={messageErrorAddTag}
                              variant="standard"
                              label="Tên nhãn"
                              {...getFieldProps("tag")}
                            ></TextField>
                            <Button
                              onClick={(e) => handleAddTag(e)}
                              color="secondary"
                              variant="contained"
                              sx={{ ml: 1, height: "46px" }}
                            >
                              Thêm nhãn
                            </Button>
                          </>
                        ) : null}
                      </Stack>
                    </>
                  )}
                </Stack>
              </Paper>
            </Grid>
          </Grid>
          <Stack direction={"row"} justifyContent={"center"}>
            <Button
              type="submit"
              sx={{ mt: 1 }}
              variant="contained"
              color="secondary"
              startIcon={<SaveIcon />}
            >
              Cập nhật
            </Button>
          </Stack>
        </Box>
      </Form>
    </FormikProvider>
  );
});
